import React from "react";

import { TaxIdCellContent as Content } from "../components";

import base from "./base";
import { Column, ColumnId } from ".";

function taxId({ width, onResize }: Column.Options) {
	return base(ColumnId.TaxId, (item) => <Content item={item} />, {
		width,
		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default taxId;
